import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Payment } from 'merchant-components'

export const Route = createFileRoute('/_merchant/_portal/payment')({
  component: Payment,
})
